import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenV = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 41,
	viewBox: "0 0 51 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M50.0088 0.165741H45.7259C45.1254 0.165741 44.5556 0.445309 44.188 0.923681L18.9255 33.3722L6.81202 17.8096C6.62877 17.5737 6.3952 17.383 6.12883 17.2517C5.86247 17.1204 5.57024 17.052 5.27409 17.0517H0.991168C0.580645 17.0517 0.353938 17.53 0.605154 17.8531L17.3876 39.4109C18.1719 40.4174 19.6792 40.4174 20.4696 39.4109L50.3948 0.960957C50.6461 0.644113 50.4194 0.165741 50.0088 0.165741Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgGreenV);
export { ForwardRef as ReactComponent };
